import _ from 'underscore';

import { isBlank } from '../helpers/common';
import Base, { baseInit } from './base';

export class User extends Base {
  id = null; // Integer
  userName = null; // String
  email = null; // String
  phone = null;
  provider = null;
  acceptedTos = false; // boolean
  enabled = true;
  flags = null; // [String]
  organizationId = null; // Integer
  userApplications = [];
  accountIds = [];
  _uuid = null;

  _flags = {}; // Lookup map of flags

  constructor(data) {
    super(data);
    baseInit(this, data, true);
    this.acceptedTos = this.acceptedTos === null ? false : this.acceptedTos;

    if (!isBlank(this.flags)) {
      this.flags
        .map((s) => s.trim().toLowerCase())
        .forEach((s) => {
          this._flags[s] = 1;
        });
    }
  }

  hasFlag(needle) {
    return _.has(this._flags, needle.toLowerCase());
  }
}
